<div class="tw-py-4 tw-pl-4 tw-pr-[14px] tw-bg-orange-25 tw-flex tw-items-center tw-justify-between tw-font-body" (click)="onBannerClick()">
  <div class="tw-flex tw-items-center tw-justify-center tw-gap-3">
    <div class="tw-w-[22px] tw-h-[22px] tw-rounded-full tw-bg-orange-700 tw-flex tw-items-center tw-justify-center">
      <img src="/assets/icons/lock-icon-white.svg" class="tw-w-[9px] tw-h-[12px]" alt="lock-icon">
    </div>
    <div>
      <p class="tw-text-300 tw-font-lexend tw-font-bold" i18n="@@yourDoctorCheckupsAreLocked">Your doctor check-ups are locked.</p>
      <p class="tw-text-200 tw-font-body tw-font-normal" i18n="@@sinceYouDidNotContinueWithTheTreatment">Since you did not continue with the treatment.</p>
    </div>
  </div>
  <div>
    <cs-icon class="tw-h-3 tw-w-3" [iconName]='"chevron_right_teal"'></cs-icon>
  </div>
</div>